import { render } from "./CriterionGroup.vue?vue&type=template&id=61b8fd20&scoped=true"
import script from "./CriterionGroup.vue?vue&type=script&lang=js"
export * from "./CriterionGroup.vue?vue&type=script&lang=js"

import "./CriterionGroup.vue?vue&type=style&index=0&id=61b8fd20&scoped=true&lang=css"
import "./CriterionGroup.vue?vue&type=style&index=1&id=61b8fd20&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b8fd20"]])

export default __exports__